import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import GlobalFields from '../../../components/TaskLayout/Fields/GlobalFields'
import FieldConfiguration from "../../../components/TaskLayout/Fields/FieldConfiguration"
import FieldConfigSchemes from '../../../components/TaskLayout/Fields/FieldConfigSchemes'

const Fields = () => {

    const [filterValues, setFilterValues] = useState({ tab: "global_fields", apiCall: true })
    const fieldTabs = [
        {
            key: "global_fields",
            label: "Global Fields"
        },
        {
            key: "field_config",
            label: "Field Configurations"
        },
        {
            key: "field_config_schemes",
            label: "Field Configuration Schemes"
        }
    ]

    return (
        <div>
            <div className='m-2 d-flex justify-content-between'>
                <div className='tab-menu'>
                    {fieldTabs?.map(item => (
                        <div className={`tab-menu-item ${item?.key === filterValues?.tab && "active"}`} onClick={() => { if (item?.key !== filterValues?.tab) { setFilterValues((prev) => ({ ...prev, tab: item?.key, apiCall: true, scheme: {}, config: {} })); } }}>{item?.label}</div>
                    ))}
                </div>
                <div>
                    <button className='sk-btn sk-btn-primary' onClick={() => setFilterValues(prev => ({ ...prev, apiCall: true }))}><FontAwesomeIcon icon="fa-solid fa-arrows-rotate" /></button>
                </div>
            </div>
            <div className='px-2'>
                {filterValues?.tab === "global_fields" && <GlobalFields filterValues={filterValues} setFilterValues={setFilterValues} />}
                {filterValues?.tab === "field_config" && <FieldConfiguration filterValues={filterValues} setFilterValues={setFilterValues} />}
                {filterValues?.tab === "field_config_schemes" && <FieldConfigSchemes filterValues={filterValues} setFilterValues={setFilterValues} />}
            </div>
        </div>
    )
}

export default Fields